import React from 'react';
import {ButtonNew} from 'components/ButtonNew';
import {IProductSnippet} from 'shared/types/productSnippet.types';

type TSubscribeButtonProps = Pick<IProductSnippet['cart'], 'onSubscribe'> & Pick<IProductSnippet, 'url'>;

export const SubscribeButton = (props: TSubscribeButtonProps) => {
    const {onSubscribe, url} = props;

    return (
        <ButtonNew
            isStretched={true}
            href={url}
            variants={{DT: 'medium', TB: 'small', MB: 'small'}}
            theme={'outline'}
            onClick={onSubscribe}
        >
            Узнать о наличии
        </ButtonNew>
    );
};
